import * as requestFromServer from './usersActionsCrud';
import {usersActionsSlice, callTypes} from './usersActionsSlice';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {v4 as guid} from 'uuid';

export const getUsersActionsListIDPrefix = 'getUsersActionsList';
const {actions} = usersActionsSlice;

const getUsersActionsList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getUsersActionsListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .getUsersActions(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalUserActivitiesCount, userActivities, pageCount}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount: totalUserActivitiesCount,
        pageCount: pageCount,
        entities: userActivities
      }));
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find users actions';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const getUsersActions = getUsersActionsList(actions.usersActionsFetched);
export const getNextUsersActions = getUsersActionsList(actions.usersActionsAppended);

export const getUserActivitiesLogsForExcelFile = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getUserActivitiesLogsForExcelFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get data!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const logUserAction = (page, subject, action, payload, result) => {
  return requestFromServer
    .logUserAction(page, subject, action, payload, result)
    .then(response => {
      const {errorCode} = response.data;

      return errorCode;
    })
    .catch((error) => {
      console.error({error});
      error.clientMessage = 'Can\'t send data!';
    });
};

